import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkRoute, payForRoute, Promoter } from '../../redux/advertSlice';
import { getContrastingColor, getLocalUTCDate, getStorageData } from '../../helpers';
import { Select } from '../../components/Select';
import { ADVERT_CITY_STORAGE_NAME, createHandlerWithStorage } from '../../helpers/localStorage';
import { Button } from '../../components/Button';
import { Link } from 'react-router-dom';
import { AdvertMonthSwitcher } from './AdvertMonthSwitcher';
import sortImg from '../../assets/sort/sort.png';
import sortDarkImg from '../../assets/sort/sort-dark.png';

const FinishItem = ({data}) => {
    const dispatch = useDispatch();
    const {city, details, promoter, route, flyers, bet, additional} = data;
    const {givenFlyersCount, finishedAt, checked, isPaid} = details;
    const {plusPayment, plusPaymentOwn, minusPayment, addPaymentComment} = additional;
    const spreadCount = givenFlyersCount[0].doneSpreadCount;
    
    const hasPartnerFlyers = data.flyers.some(f => !f.isOwn);
    const [isBtnBlocked, setBtnBlocked] = useState(false);
    
    const totalSum = Math.floor(+(spreadCount*bet + plusPaymentOwn + plusPayment - minusPayment).toFixed(2));
    const payment = hasPartnerFlyers ?   //С партнерами
        Math.floor(+((spreadCount*bet + plusPayment)/2 + plusPaymentOwn - minusPayment).toFixed(2))
        : totalSum
    
    function splitBonusString() {
        const plus = (plusPayment || '') && '+' + plusPayment;
        const plusOwn = (plusPaymentOwn || '') && '+' + plusPaymentOwn;
        const minus = (minusPayment || '') && '-' + minusPayment;
        const comm = addPaymentComment && ` (${addPaymentComment})`;
        return `${plus}${plusOwn}${minus}${comm}`
    }
    const checkRouteHandler = (e) => {
        e.preventDefault();
        setBtnBlocked(true)
        dispatch(checkRoute({finishId: data._id, enableBtn: () => setBtnBlocked(false)}));
    }
    const payRouteHandler = (e) => {
        e.preventDefault();
        setBtnBlocked(true)
        dispatch(payForRoute({finishId: data._id, enableBtn: () => setBtnBlocked(false)}));
    }
    
    return (
        <Link to={`../finished_route/${data._id}`} className={`finished-routes__item ${checked ? 'checked':''} ${isPaid ? 'paid':''}`}>
            <div>{getLocalUTCDate(city.UTC, finishedAt)}</div>
            <div>(id{promoter.id}) {promoter.fullname}</div>
            <div>{promoter.paymentDetails || 'Не указаны'}</div>
            <div>#{route.id}</div>
            <div className='finished-routes__item-flyer'>
                {flyers.map(f => <span key={f._id} style={{backgroundColor: f.details.backgroundColor, color: getContrastingColor(f.details.backgroundColor)}}>{f.name}</span>)}
            </div>
            <div>{spreadCount}</div>
            <div>{bet}</div>
            <div title={splitBonusString()}>{splitBonusString()}</div>
            <div>{totalSum}</div>
            <div className='finished-routes__item-action'>
                <div>{payment} руб</div>
                {!isPaid && checked && <Button text='Оплатить' disabled={isBtnBlocked} onClick={(e) => payRouteHandler(e)}/>}
                {!checked && <Button text='Проверить' disabled={isBtnBlocked} onClick={(e) => checkRouteHandler(e)}/>}
            </div>
        </Link>
    );
};

export const FinishedRoutes = ({ cities, promoters, months }) => {
    const dispatch = useDispatch();

    const [city, setCity] = useState(getStorageData(cities, ADVERT_CITY_STORAGE_NAME));
    const setCityHandler = createHandlerWithStorage(setCity, ADVERT_CITY_STORAGE_NAME);

    const finishedRoutes = useSelector((state) => state.advert.finishedRoutes);
    const thisRoutes = finishedRoutes.filter(fr => fr.city._id === city && fr.details.needPay).map(fr => 
        ({
            ...fr,
            orderIndex: fr.details.isPaid ? 2 : fr.details.checked ? 0 : 1}));
    const activeMonth = months.find(m => m.active);
    const thisMonthRoutes = thisRoutes.filter(r => r.details.timestamp === activeMonth.timestamp);

    const isLightTheme = useSelector(state => state.app.isLightTheme);
        const [sort, setSort] = useState({type: 'date', isASC: false});
        const setSortHandler = (type) => {
            if (sort.type === type) {
                setSort(prev => ({...prev, isASC: !sort.isASC}));
                return;
            }
            setSort({type, isASC: false})
        }
        const tableHeaders = [
            {type:"date", label: 'Дата'}, {type:"promoter", label: 'Пром'},
            {type:"req", label: 'Реквизиты'}, {type:"route", label: 'Маршрут'},
            {type:"flyers", label: 'Листовки'}, {type:"spread", label: 'Разнес'},
            {type:"bet", label: 'Ставка'}, {type:"add", label: 'Доп'},
            {type:"result", label: 'Итого'}, {type:"pay", label: 'К оплате'}
        ]
        
        const TableTitle = ({type, label}) => {
            const isSortByThis = sort.type === type;
            const isASC = sort.isASC;
            return (
                <div onClick={() => setSortHandler(type)} style={{cursor: 'pointer', userSelect: 'none'}}>
                    {label}
                    {isSortByThis && <img src={isLightTheme ? sortImg : sortDarkImg} style={{transform: `rotate(${isASC?180:0}deg)`}} alt="" />}
                </div>
            )
        }
        const createSortFn = ({type, isASC}) => {
            switch (type) {
                case 'date': return (a, b) => isASC ? a.orderIndex === b.orderIndex ? b.details.finishedAt - a.details.finishedAt : a.orderIndex - b.orderIndex : a.details.finishedAt - b.details.finishedAt;
                case 'promoter': return (a, b) => isASC ? b.promoter.fullname.localeCompare(a.promoter.fullname) : a.promoter.fullname.localeCompare(b.promoter.fullname);
                case 'req': return (a, b) => isASC ? b.promoter.phoneNumber.localeCompare(a.promoter.phoneNumber) : a.promoter.phoneNumber.localeCompare(b.promoter.phoneNumber);
                case 'route': return (a, b) => isASC ? b.route.id - a.route.id : a.route.id - b.route.id;
                case 'flyers': return ((a, b) => isASC ? b.spreadFlyers.length - a.spreadFlyers.length : a.spreadFlyers.length - b.spreadFlyers.length);
                case 'spread': return (a, b) => {
                    const { details: details1} = a;
                    const {givenFlyersCount:givenFlyersCount1} = details1;
                    const spreadCount1 = givenFlyersCount1[0].doneSpreadCount;

                    const { details: details2} = b;
                    const {givenFlyersCount:givenFlyersCount2} = details2;
                    const spreadCount2 = givenFlyersCount2[0].doneSpreadCount;

                    return isASC ? spreadCount2 - spreadCount1 : spreadCount1 - spreadCount2;
                }
                case 'bet': return (a, b) => isASC ? b.bet - a.bet : a.bet - b.bet;
                case 'add': return (a, b) => {
                    const add1 = a.additional.plusPayment+a.additional.plusPaymentOwn-a.additional.minusPayment;
                    const add2 = b.additional.plusPayment+b.additional.plusPaymentOwn-b.additional.minusPayment;
                    return isASC ? add2 - add1 : add1 - add2;
                }
                case 'result': return (a, b) => {
                    function calc(data) {
                        const {details, bet, additional} = data;
                        const {givenFlyersCount} = details;
                        const {plusPayment, plusPaymentOwn, minusPayment} = additional;
                        const spreadCount = givenFlyersCount[0].doneSpreadCount;
                        return Math.floor(+(spreadCount*bet + plusPaymentOwn + plusPayment - minusPayment).toFixed(2));
                    }
                    const pay1 = calc(a);
                    const pay2 = calc(b);
                    return isASC ? pay2 - pay1 : pay1 - pay2;
                }
                case 'pay': return (a, b) => {
                    function calc(data) {
                        const {details, bet, additional} = data;
                        const {givenFlyersCount} = details;
                        const {plusPayment, plusPaymentOwn, minusPayment} = additional;
                        const spreadCount = givenFlyersCount[0].doneSpreadCount;
                        const hasPartnerFlyers = data.flyers.some(f => !f.isOwn);
                        const totalSum = Math.floor(+(spreadCount*bet + plusPaymentOwn + plusPayment - minusPayment).toFixed(2));
                        return hasPartnerFlyers ?   //С партнерами
                        Math.floor(+((spreadCount*bet + plusPayment)/2 + plusPaymentOwn - minusPayment).toFixed(2))
                        : totalSum
                    }
                    const payment1 = calc(a);
                    const payment2 = calc(b);
                    return isASC ? payment2 - payment1 : payment1 - payment2;
                }
                default: return () => true;
            }
        }
        const sortedList = [...thisMonthRoutes].sort(createSortFn(sort));

    return (
        <div className="finished-routes">
            <div className="container">
                <div className="finished-routes__manager">
                    <div className="finished-routes__select-city">
                        <Select
                            enums={cities}
                            value={city}
                            changeHandler={(e) => setCityHandler(e.target.value)}
                        />
                    </div>
                </div>
                <div className="finished-routes__body">
                    <div className="finished-routes__table">
                        <div className="finished-routes__titles">
                            {tableHeaders.map(th => <TableTitle key={th.type} type={th.type} label={th.label}/>)}
                        </div>
                        {sortedList.map(r => <FinishItem key={r._id} data={r} />)}
                        {/* {[...sortedList].sort((a,b) => a.orderIndex === b.orderIndex ? b.details.finishedAt - a.details.finishedAt : a.orderIndex - b.orderIndex).map(r => <FinishItem key={r._id} data={r} />)} */}
                    </div>
                </div>
                <div className="finished-routes__footer">
                    <AdvertMonthSwitcher months={months} />
                </div>
            </div>
        </div>
    );
};
